module.exports = __webpack_public_path__ + "static/media/mito01.70324626.jpg";